
import { defineComponent } from "vue";
import LButtom from "@/components/LButtom/LButtom.vue";
import { login } from "../../../api/auth";
import { setlocalStorage } from "@/helpers/setLocalStore";
import { mapMutations } from "vuex";
import LInput from "@/components/form/LInput.vue";

export default defineComponent({
  name: "LLoginForm",
  components: { LInput, LButtom },
  data() {
    return {
      email: "",
      password: "",
      Login_text: "Login",
      isErr: false,
    };
  },
  methods: {
    ...mapMutations(["updateSateFromStorage", "setLinks"]),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    focus(event: any) {
      event.target.parentNode.classList.add("focus-inputs");
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    focusRemove(event: any) {
      event.target.parentNode.classList.remove("focus-inputs");
    },

    sendData() {
      this.Login_text = "Cargando..";
      login(this.email, this.password)
        .then((res) => {
          if (res.error) {
            this.Login_text = "Login";
            this.isErr = true;

            setTimeout(() => {
              this.isErr = false;
            }, 1500);
          }

          if (res.token) {
            this.Login_text = "Login";
            setlocalStorage(res.token, res.user, true);
            this.setLinks(res.links);
            this.updateSateFromStorage();
            this.$router.push("/home");
          }
        })
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .catch(() => {
          return;
        });
    },
  },
});
